import { render, staticRenderFns } from "./apply-table-view.vue?vue&type=template&id=b0b58b82&"
import script from "./apply-table-view.vue?vue&type=script&lang=js&"
export * from "./apply-table-view.vue?vue&type=script&lang=js&"
import style0 from "./apply-table-view.vue?vue&type=style&index=0&id=b0b58b82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports